// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-title-tag {\n  background-color: #def1ef;\n  padding: 0.5rem 1.5rem;\n  border-radius: 50px;\n}\n.page-title-tag p {\n  margin: 0;\n  padding: 0;\n  color: var(--green);\n  font-size: 0.88rem;\n}\n.page-title-tag .tag-icon {\n  width: 18px;\n  height: 18px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
